import { FC, useMemo } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

import AppTitle from '../../app-title'
import NotFound from '../not-found'
import SafetyCasesListPage from './safety-cases-page/safety-cases-page'
import UpdateSafetyCasePage from './safety-case-page/update-safety-case-page'
import UpdateSafetyCaseHazardPage from './safety-case-hazard-page/update-safety-case-hazard-page'
import CreateSafetyCaseHazardPage from './safety-case-hazard-page/create-safety-case-hazard-page'

import useFeatureFlags from '../../features/use-feature-flags'
import { useAccessControl, claims } from '../../security'
import { buildPath } from '../../util'

type SafetyCaseProps = {
  basePath: string
  baseTitle: string
}

const SafetyCase: FC<SafetyCaseProps> = props => {
  const { baseTitle, basePath } = props

  const { hasAccess } = useAccessControl()

  const { safetyManagementEnabled } = useFeatureFlags()

  const hasSafetyCaseAnyAccess = useMemo(
    () => hasAccess([claims.safetyCase.read, claims.safetyCase.write]),
    [hasAccess],
  )

  if (!safetyManagementEnabled || !hasSafetyCaseAnyAccess) {
    return <NotFound />
  }

  return (
    <AppTitle title={baseTitle + 'Safety Cases'}>
      <Routes>
        <Route index element={<Navigate to={buildPath('/safety-case-list', basePath)} replace />} />

        <Route path="/safety-case-list" element={<SafetyCasesListPage />} />

        <Route path="/:safetyCaseId/*" element={<UpdateSafetyCasePage />} />

        <Route path="/:safetyCaseId/hazards/new/*" element={<CreateSafetyCaseHazardPage />} />

        <Route path="/:safetyCaseId/hazards/:hazardId/*" element={<UpdateSafetyCaseHazardPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppTitle>
  )
}

export default SafetyCase
